import { render, staticRenderFns } from "./AddBanner.vue?vue&type=template&id=149a915b"
import script from "./AddBanner.vue?vue&type=script&lang=js"
export * from "./AddBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports